export const addWebp = (): string => {
  const isIE = navigator.userAgent.indexOf('MSIE ') > -1;
  const isSafari = navigator.userAgent.indexOf('Safari') > -1 && navigator.userAgent.indexOf('Chrome') === -1;
  const browserSupportsWebp = !(isIE || isSafari);

  return browserSupportsWebp ? '&f=4' : '';
};
